import { getJSON } from 'bv-fetch';

export default (loggedIn, locale) => (
  getJSON(`/api/footer_settings?l=${loggedIn}&c=${locale}`)
);
